import ExternalAuth from '@web/containers/ExternalAuth/ExternalAuth';
import { Suspense } from 'react';
import ErrorBoundary from '../components/ErrorBoundary';

export function Component() {
  return (
    <ErrorBoundary>
      <Suspense fallback={null}>
        <ExternalAuth />
      </Suspense>
    </ErrorBoundary>
  );
}

Component.displayName = 'ExternalAuth';
